import { createContext } from 'react';

export interface AccountInfo {
  id: string;
  name: string;
  subdomain: string;
  senderId: string;
  hasMacros: boolean;
  isReactBroadcasts: boolean;
  salesforceInstance: string;
  usSmsRate: number;
  usMmsRate: number;
  sendStopMessage: string;
  sendStop: boolean;
  enforceSenderId: boolean;
  enableMmsBroadcasts: boolean;
  plan: 'trial-plan-4' | 'standard-plan-4' | 'lite-plan-4',
  hasAnalytics: boolean;
  lookerAnalytics: boolean;
  metabase: boolean;
  organizationId: string;
  adjustForOfficeHours: boolean;
  adjustForAssignment: boolean;
  createdAt: any;
  isTrial: any;
  phoneNumber: string;
  isMessagingServiceSid: boolean;
  isTollFreeNumber: boolean;
  hasTollFreeNumber: boolean;
  isAvoVerified: boolean;
  isTcrCampaign: boolean;
  hasTcrBrand: boolean;
  boostedBroadcastsEnabled: boolean;
  helperBotTargetAccount?: boolean;
  helperBotEnabled?: boolean;
  trialSurveyCompletion?: 'none' | 'q1' | 'q2' | 'q3' | 'q3_plus_payoff';
}

export const AccountInfoContext = createContext<AccountInfo>({
  id: null,
  name: null,
  subdomain: null,
  senderId: null,
  hasMacros: null,
  isReactBroadcasts: null,
  salesforceInstance: null,
  usSmsRate: null,
  usMmsRate: null,
  sendStopMessage: null,
  sendStop: null,
  enforceSenderId: null,
  enableMmsBroadcasts: null,
  plan: null,
  hasAnalytics: null,
  lookerAnalytics: null,
  metabase: null,
  organizationId: null,
  adjustForOfficeHours: null,
  adjustForAssignment: null,
  createdAt: null,
  isTrial: null,
  phoneNumber: null,
  isMessagingServiceSid: null,
  isTollFreeNumber: null,
  hasTollFreeNumber: null,
  isAvoVerified: null,
  isTcrCampaign: null,
  hasTcrBrand: null,
  boostedBroadcastsEnabled: null,
  helperBotTargetAccount: null,
  helperBotEnabled: false,
  trialSurveyCompletion: 'none',
});
